import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { FiCalendar } from 'react-icons/fi';
import styles from './DateRangePicker.module.scss';

const { RangePicker } = DatePicker;

// Value/onChange work in plain JS Dates (not dayjs objects) so consumers
// don't need to know or care which date library the picker uses internally.
export const DateRangePickerComponent = ({
  value,
  onChange,
  format = 'DD MMM YYYY',
  placeholder = ['Start date', 'End date'],
  allowClear = false,
  className,
}) => {
  const dayjsValue = value ? [dayjs(value[0]), dayjs(value[1])] : null;

  const handleChange = (dates) => {
    if (!dates || !dates[0] || !dates[1]) {
      onChange?.(null);
      return;
    }
    onChange?.([dates[0].toDate(), dates[1].toDate()]);
  };

  return (
    <RangePicker
      className={`${styles.rangePicker} ${className || ''}`}
      value={dayjsValue}
      onChange={handleChange}
      format={format}
      placeholder={placeholder}
      allowClear={allowClear}
      suffixIcon={<FiCalendar size={14} color="var(--gray-500)" />}
    />
  );
};

DateRangePickerComponent.displayName = 'DateRangePicker';
